import Button from "@/components/button"
import Modal from "@/components/modal"
import useCategoryRepos from "@/repositories/category"

import { useState } from "react"

import nprogress from 'nprogress'
import axios from "axios"
import toast from "react-hot-toast"
import { useAuth } from "@/contexts/auth-context"
import { Pencil } from "@/components/icons/outline"

const Content = ({ data, onSubmit }) => {
    // Contexts
    const { user, token } = useAuth()

    // Data
    const { data: categoryData, isLoading: isLoadingCategoryData } = useCategoryRepos()

    // Forms
    const [content, setContent] = useState(data.content)
    const [categoryId, setCategoryId] = useState(data.categoryId)

    const [errors, setErrors] = useState({})

    const handleSubmit = (e) => {
        e.preventDefault()

        nprogress.start()

        toast.loading("Loading", {
            id: "submit"
        })

        const url = `${process.env.REACT_APP_API_URL}/posts/${data.id}`
        const payload = {
            content,
            categoryId
        }

        axios.put(url, payload, { headers: { Authorization: `Bearer ${token}` } }).then((response) => {
            // Clear SWR cache
            // cache.clear()

            // Run on submit props
            onSubmit(content)

            // Show toast message
            toast.success(response.data.message, {
                id: "submit"
            })
        }).catch((error) => {
            // Assign validation data
            // if (error.response.status === 400) {
            //     setErrors(error.response.data.errors)
            // }

            // Show toast message
            toast.error(error.response.data.message, {
                ariaProps: {
                    superscript: error.response.status
                },
                id: "submit"
            })
        })
    }

    return (
        <form onSubmit={handleSubmit} className="flex flex-col w-full space-y-6">
            <div className="flex justify-between w-full">
                <div className="flex space-x-4">
                    <div className="relative">
                        <img className="w-10 h-10 rounded-xl" src={`https://ui-avatars.com/api/?name=${user?.name}`} alt={`${user?.name}'s Profile Picture`} />
                    </div>
                    <div className="flex flex-col items-start justify-center">
                        {/* Name */}
                        <p className="text-sm font-semibold">{user?.name}</p>
                    </div>
                </div>
                {/* <div className="px-3 py-1 text-xs font-medium text-blue-500 bg-blue-100 border border-blue-500 rounded-full h-fit">{row.category?.name}</div> */}
            </div>
            <div className="flex flex-wrap">
                <input required onChange={(e) => setContent(e.target.value)} value={content} type="text" placeholder="What's up?" className="flex-wrap w-full text-sm focus:outline-none" />
            </div>
            {/* <div>
                <select required onChange={(e) => setCategoryId(e.target.value)} value={categoryId} name="category" id="category" className="px-4 py-2 text-sm border rounded-xl">
                    <option value="">- Select Category -</option>
                    {!isLoadingCategoryData && categoryData?.map((row) => (
                        <option value={row.id}>{row.name}</option>
                    ))}
                </select>
            </div> */}
            <div className="flex items-center justify-between">
                <div></div>
                <Button type="submit">
                    <div className="text-sm font-semibold">Submit</div>
                </Button>
            </div>
        </form>
    )
}

export default function EditPost({ data, onSubmit }) {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => {
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    const handleSubmit = (value) => {
        closeModal()
        onSubmit(value)
    }

    return (
        <>
            <button onClick={() => openModal()}>
                <Pencil />
            </button>
            <Modal title="Edit Post" size="2xl" onClose={() => closeModal()} isOpen={isOpen} content={<Content data={data} onSubmit={handleSubmit} />} />
        </>
    )
}